<template>
  <v-card class="card_setting">
    <v-card>
      <v-card-title>
        <v-avatar tile size="36" class="mr-4">
          <v-img :src="require('../../../assets/icon/type_of_word.svg')"></v-img>
        </v-avatar>
        <h1>Type of word</h1>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="master_data"
        :search="search"
        id="table-text"
        class="elevation-1"
      >
        <template v-slot:top style="font-size:30px;">
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark class="mb-2 bg_btn_gradient" v-bind="attrs" v-on="on">
                  <v-icon left>mdi-plus-circle</v-icon>
                  <span class="text_body_6">New Item</span>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-form ref="form" @submit.prevent="save">
                  <v-card-text class="py-0">
                    <v-container>
                      <v-row>
                        <v-col class="py-0">
                          <v-text-field
                            v-model="type"
                            dense
                            outlined
                            label="Type Name"
                            :rules="rule_empty"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      <h4>Cancel</h4>
                    </v-btn>
                    <v-btn color="blue darken-1" text type="submit">
                      <h4>Save</h4>
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.no="{ item }">{{ master_data.indexOf(item) + 1 }}.</template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data></template>
      </v-data-table>
    </v-card>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      type: null,
      rule_empty: [(v) => !!v || "require"],
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },

      api_url: "api/v1/masterdata/type",
      dialog: false,
      search: "",
      headers: [
        {
          text: "No.",

          sortable: false,
          value: "no",
        },

        {
          text: "Type",
          value: "typeName",
          sortable: false,
          width: "100%",
        },

        { text: "Actions", value: "actions", sortable: false },
      ],

      editedIndex: -1,

      master_data: [],
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.getMasterData();
  },

  methods: {
    getMasterData() {
      this.axios
        .get(process.env.VUE_APP_API + this.api_url, this.header_token)
        .then((res) => {
          this.master_data = res.data;
        });
    },
    post() {
      var data = {
        typeName: this.type,
      };

      this.axios
        .post(process.env.VUE_APP_API + this.api_url, data, this.header_token)
        .then((res) => {
          if (res.data == "create success") {
            this.$swal.fire({
              icon: "success",
              title: "Create Success",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getMasterData();
          }
        });
    },
    put() {
      var id = this.master_data[this.editedIndex].typeId;
      var data = {
        typeName: this.type,
      };

      this.axios
        .put(
          process.env.VUE_APP_API + this.api_url + "/" + id,
          data,
          this.header_token
        )
        .then((res) => {
          if (res.data == "update success") {
            this.$swal.fire({
              icon: "success",
              title: "Update Success",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getMasterData();
          }
        });
    },
    deleteItem(item) {
      var id = item.typeId;
      this.$swal
        .fire({
          title: "Are you sure you want to delete this item?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "Delete",
          cancelButtonText: "Cancel",
        })
        .then((res) => {
          if (res.value == true) {
            this.axios
              .delete(
                process.env.VUE_APP_API + this.api_url + "/" + id,
                this.header_token
              )
              .then((res) => {
                if (res.data == "delete success") {
                  this.$swal.fire({
                    icon: "success",
                    title: "Delete Success",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  this.getMasterData();
                }
              });
          }
        });
    },

    editItem(item) {
      this.type = item.typeName;
      this.editedIndex = this.master_data.indexOf(item);
      this.dialog = true;
    },

    close() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.editedIndex > -1) {
        if (this.$refs.form.validate()) {
          this.put();
          this.close();
        }
      } else {
        if (this.$refs.form.validate()) {
          this.post();
          this.close();
        }
      }
    },
  },
};
</script>
